import { lightTheme } from 'scorer-ui-kit';
export const hollowPointsTheme = () => {
  lightTheme.custom.lines.primary = {
    'label': {
      'fill': '#fff'
    },
    'contrastLine': {
      'stroke': 'transparent;'
    },
    'highlightLine': {
      'stroke': 'hsla(205deg, 80%, 45%, 100%)'
    },
    'grabHandle': {
      'fill': 'transparent',
      'stroke': 'transparent'
    },
    'point': {
      'fill': 'rgb(0, 0, 0, 0.8)'
    },
    'grabHandleContrast': {
      'stroke': 'transparent'
    },
    'grabHandleText': {
      'fill': 'hsla(205deg, 80%, 25%, 100%);'
    },
    'handleBase': {
      'fill': 'transparent'
    },
    'handleRingLayer': {
      'stroke': 'hsla(205deg,100%,89%,100%)'
    },
    'handleReactiveFill': {
      'fill': 'transparent'
    },
    'handleReactiveRing': {
      'stroke': 'transparent'
    },
    'handleContrastLayer': {
      'stroke': 'transparent'
    },
    'stopStart': {
      'stopColor': 'transparent'
    },
    'stopEnd': {
      'stopColor': 'transparent'
    }
  };
  return lightTheme;
};